export default "__VITE_ASSET__Df$SxWiV__"